import { ICompanyLogo } from '@qima-labs/app/pages/main/shared/components/header/shared/interfaces/companyLogo.interface';
import { SERVER_URL } from '@qsp-ui-library/constants/app.constants';
import { LANGUAGES } from '@qsp-ui-library/constants/languages.constants';
import { EStorageKeys } from '@qsp-ui-library/models/enums/storage-keys.enum';
import { ESupportedLanguage } from '@qsp-ui-library/models/enums/supported-language.enum';
import { IHttpResponseBody } from '@qsp-ui-library/models/interfaces/http-response-body.interface';
import { IUser } from '@qsp-ui-library/models/interfaces/user.interface';
import { QimaNullableType } from '@qsp-ui-library/models/types/qima.type';
import { AppBrowserDetectService } from '@qsp-ui-library/services/browser-services/app-browser-detect/app-browser-detect.service';
import { HttpService } from '@qsp-ui-library/services/http-services/http.service';
import { StorageService } from '@qsp-ui-library/services/storage-services/storage.service';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import localForage from 'localforage';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public readonly isProfileMenuVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly isTranslateMenuVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public activeLanguageIndex$: Subject<number> = new Subject<number>();
  public activeLanguageIndex: number = 1;
  public readonly companyLogo$: Subject<string> = new Subject<string>();

  public constructor(
    private readonly _appBrowserDetectService: AppBrowserDetectService,
    private readonly _storageService: StorageService,
    private readonly _httpService: HttpService,
    private readonly _appAuthenticationService: AppAuthenticationService
  ) {
    void localForage.getItem(EStorageKeys.LOCALE_LANGUAGE).then((data): void => {
      const language = data || this._appBrowserDetectService.getSupportedBrowserLanguage() || ESupportedLanguage.ENGLISH;

      this.setActiveLanguageIndex(LANGUAGES.findIndex((item): boolean => item.value === language));
      this.activeLanguageIndex$.next(LANGUAGES.findIndex((item): boolean => item.value === language));
    });
  }

  public getCompanyLogo$(): Observable<QimaNullableType<string>> {
    const userId = this._storageService.getItem(EStorageKeys.USER_ID);
    const user: IUser = this._appAuthenticationService.getCurrentUser();

    if (!user?.company?.id) {
      return of(null);
    }

    return this._httpService.httpClient
      .get<ICompanyLogo>(`${SERVER_URL}/user/${userId}/company/${user.company.id}/logo`, { observe: 'response' })
      .pipe(map((response: Readonly<HttpResponse<ICompanyLogo>>): QimaNullableType<string> => response?.body?.image || null));
  }

  public getManagerAvatar$(sicId: string): Observable<QimaNullableType<string>> {
    return this._httpService.httpClient
      .get<IHttpResponseBody<string>>(`${SERVER_URL}/parameter/sic/${sicId}/base64?refresh=true`, { observe: 'response' })
      .pipe(map((response: Readonly<HttpResponse<IHttpResponseBody<string>>>): QimaNullableType<string> => response?.body?.content || null));
  }

  public updateIsProfileMenuVisible(isProfileMenuVisible: boolean): void {
    this.isProfileMenuVisible$.next(isProfileMenuVisible);
  }

  public updateIsTranslateMenuVisible(isTranslateMenuVisible: boolean): void {
    this.isTranslateMenuVisible$.next(isTranslateMenuVisible);
  }

  public updateActiveLanguageIndex(index: number): void {
    this.activeLanguageIndex$.next(index);
    this.setActiveLanguageIndex(index);
  }

  public updateCompanyLogo(logo: string): void {
    this.companyLogo$.next(logo);
  }

  public getActiveLanguageIndex(): number {
    return this.activeLanguageIndex;
  }

  public setActiveLanguageIndex(index: number): void {
    this.activeLanguageIndex = index;
  }
}
